/** ANCHOR: vk-group-announcement-modal — логика показа один раз (удалить вместе с модалкой). */
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  markVkGroupAnnouncementShown,
  wasVkGroupAnnouncementShown,
} from '../../constants/vkGroupAnnouncement';
import VkGroupAnnouncementModal from './VkGroupAnnouncementModal';

export default function VkGroupAnnouncementBoot() {
  const { loading, guestHtml } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loading || guestHtml) return undefined;
    if (wasVkGroupAnnouncementShown()) return undefined;
    const path = location.pathname || '';
    if (path.startsWith('/browser-login')) return undefined;
    setOpen(true);
    return undefined;
  }, [loading, guestHtml, location.pathname]);

  const handleClose = useCallback(() => {
    markVkGroupAnnouncementShown();
    setOpen(false);
  }, []);

  if (!open) return null;
  return <VkGroupAnnouncementModal onClose={handleClose} />;
}
